<section class="grid-x {{article().attributes.bg}}-content">
  <div class="container temp-spacer grid-x grid-margin-x article">
    <article [@loadTriggerRight]="'inRight'" class="article__main cell"
      [ngClass]="article().attributes.image ? 'large-8' : 'large-12'">
      <div class="article__content">
        <h3 class="center-text">{{article().attributes.title}}</h3>
        <p class="center-text">{{article().attributes.content}}</p>
      </div>
    </article>
    @if (article().attributes.image && !article().attributes.imageIsFile) {
      <aside
        [@loadTriggerRight]="'inRight'" class="cell article__image--right large-4">
        <div class="article__image--content"
        [ngStyle]="{'background-image': 'url(' + (image | async)  + ')'}" >
          @if (article().attributes.picture_text) {
            <small class="article__image--subtext">{{article().attributes.picture_text}}</small>
          }
        </div>
      </aside>
    }
    @if (article().attributes.fileLink && article().attributes.imageIsFile) {
      <aside
        [@loadTriggerRight]="'inRight'" class="cell article__image--right large-4">
        <div class="article__image--content"
        [ngStyle]="{'background-image': 'url(' + image  + ')'}" >
          @if (article().attributes.picture_text) {
            <small class="article__image--subtext">{{article().attributes.picture_text}}</small>
          }
        </div>
      </aside>
    }
  </div>
  @if (editMode()) {
    <div class="edit-buttons">
      <button class="button" (click)="editArticle()">edit</button>
      <button class="button" (click)="deleteArticle()">delete</button>
    </div>
  }
</section>
